import { SideNavigationItem } from './navigation-items.constants';

export function filterNavItems(
  items: SideNavigationItem[],
  permissions: string[],
): SideNavigationItem[] {
  return items.filter((item) => {
    if (!item.requiredPermissions) return true;

    return item.requiredPermissions.some((p) => permissions.includes(p));
  });
}

/** Required permissions declared for a route (matched by its `routerLink` === route `path`). */
export function getRequiredPermissions(
  items: SideNavigationItem[],
  routerLink: string,
): string[] | undefined {
  return items.find((item) => item.routerLink === routerLink)?.requiredPermissions;
}
